import type { FunctionComponent } from "react"

import { NIL } from "uuid"

import { Divider } from "@jobteaser/spark/components/Divider"

import { useCareerCenterFetch } from "@/modules/careerCenter/hooks/useCareerCenterFetch"
import { useTranslation } from "@/modules/i18n/components/useTranslation"
import { CcFilters } from "@/modules/jobAds/client/components/CcFilters/CcFilters"
import { JobsWithImpactFilterShortcut } from "@/modules/jobAds/client/components/JobsWithImpactFilterShortcut/JobsWithImpactFilterShortcut"
import { SecondaryFilters } from "@/modules/jobAds/client/components/SecondaryFilters/SecondaryFilters"
import { JOBS_WITH_IMPACT, JOBS_WITH_IMPACT_VARIANTS } from "@/modules/jobAds/client/constants/flags"
import { useFlag } from "@/modules/unleash/hooks/useFlag"

import styles from "./SecondaryFiltersBar.module.css"

export const SecondaryFiltersBar: FunctionComponent = () => {
  const { t } = useTranslation(["job_ads_fo"])
  const { dataCareerCenter } = useCareerCenterFetch()
  const isJobsWithImpactFilterVisible = useFlag(JOBS_WITH_IMPACT, JOBS_WITH_IMPACT_VARIANTS.ENABLED)

  const isCCFilterVisible = dataCareerCenter && dataCareerCenter.id !== NIL

  return (
    <div className={styles.main}>
      {isCCFilterVisible && (
        <CcFilters
          label={t("job_ads_fo.client.search.cc_filter.label", { schoolName: dataCareerCenter.shortName })}
          logoSrc={dataCareerCenter.logo}
          schoolName={dataCareerCenter.shortName}
        />
      )}
      {isJobsWithImpactFilterVisible && (
        <JobsWithImpactFilterShortcut>
          {t("job_ads_fo.client.search.jobs_wth_impact_filter.button_label")}
        </JobsWithImpactFilterShortcut>
      )}
      {(isCCFilterVisible || isJobsWithImpactFilterVisible) && (
        <Divider onBackground="dark" orientation="vertical" className={styles.divider} />
      )}
      <SecondaryFilters
        isJobsWithImpactFilterVisible={isJobsWithImpactFilterVisible}
        label={t("job_ads_fo.client.search.secondary_filter.button_label")}
      />
    </div>
  )
}
